let curriculum = {};
let audioMap = {};
let imageMap = {};

export const setCurriculum = (gc) => { curriculum = gc; };
export const setAudioMap = (am) => { audioMap = am; };
export const setImageMap = (im) => { imageMap = im; };

export const getAudioMap = () => audioMap;
export const getImageMap = () => imageMap;

let levelProgress = null;
const getLevelProgress = () => {
  if (!levelProgress) {
    levelProgress = Object.values(curriculum.levels).map(level => level.questions.length);
    levelProgress.forEach((levelLength, index) => {
      if (index > 0) {
        levelProgress[index] = levelProgress[index - 1] + levelLength;
      }
    });
  }
  return levelProgress;
};

export const progressToLevelQuestion = (progress) => {
  const progresses = getLevelProgress();
  const levelIndex = progresses.findIndex(length => length > progress);
  const level = levelIndex === -1 ? (progresses.length - 1) : levelIndex;
  const question = level === 0 ? progress : (progress - progresses[level - 1]);
  return { level, question };
};

export const levelToProgress = level => (level === 0 ? 0 : getLevelProgress()[level - 1]);

export const getLevelLength = (level) => {
  const { levels } = curriculum;
  const levelIndex = level + 1;

  return levels && levelIndex in levels ? levels[levelIndex].questions.length : 0;
};

export const isLastQuestionInLevel = (progress, level) => {
  const endLevelProgress = getLevelProgress()[level];
  return progress === endLevelProgress;
};

export const getNumberOfLevels = () => Object.values(curriculum.levels).length;

// helper function that puts together the choices array
// from the curriculum json for each level
export const getStandardChoices = (progress) => {
  const { level, question } = progressToLevelQuestion(progress);
  const {
    targetPart1,
    part1Distractor1,
    part1Distractor2,
    targetPart2,
    part2Distractor1,
    part2Distractor2,
  } = curriculum.levels[`${level + 1}`].questions[question];

  if (part1Distractor2 === 'NA' || part2Distractor2 === 'NA') {
    return [
      targetPart1,
      part1Distractor1,
      targetPart2,
      part2Distractor1,
    ];
  }
  return [
    targetPart1,
    part1Distractor1,
    part1Distractor2,
    targetPart2,
    part2Distractor1,
    part2Distractor2,
  ];
};

export const getOnboardingChoices = (levelType) => {
  const {
    targetPart1,
    part1Distractor1,
    part1Distractor2,
    targetPart2,
    part2Distractor1,
    part2Distractor2,
  } = curriculum.onboarding[levelType];

  if (part1Distractor2 === 'NA' || part2Distractor2 === 'NA') {
    return [
      targetPart1,
      part1Distractor1,
      targetPart2,
      part2Distractor1,
    ];
  }
  return [
    part1Distractor1,
    targetPart1,
    part1Distractor2,
    targetPart2,
    part2Distractor1,
    part2Distractor2,
  ];
};

// a helper function that puts together the correct answers array
// from the gameCurriculum json for each level
// remove the .mp3 if it has one to match getStandardChoices format
export const getAnswers = question => [
  question.targetPart1,
  question.targetPart2,
];

export const getStandardQuestion = (progress) => {
  const { level, question } = progressToLevelQuestion(progress);
  return curriculum.levels[`${level + 1}`].questions[question];
};

export const getOnboardingQuestion = levelType => curriculum.onboarding[levelType];

export const getLevelType = level => curriculum.levels[`${level + 1}`].type;
